(function () {
  'use strict';

  const SELECTORS = {
    productItem: '.grid-product',
    productData: '.product-grid-item',
    filterInput: '.custom-filter__input',
    priceMin: '[data-price-min]',
    priceMax: '[data-price-max]',
    priceApply: '[data-price-apply]',
    clearWrap: '[data-custom-filter-clear-wrap]',
    clearBtn: '[data-custom-filter-clear]',
    productGrid: '.collection-grid',
    productCount: '.collection-filter__item--count',
    brandFilterList: '[data-custom-filter="brand"]',
  };

  function getActiveFilters() {
    const filters = { vendor: [], brand: [], type: [], tag: [], available: [] };
    document.querySelectorAll(SELECTORS.filterInput + ':checked').forEach((input) => {
      const filterType = input.getAttribute('data-filter-type');
      if (filters[filterType] !== undefined) {
        filters[filterType].push(input.value);
      }
    });
    return filters;
  }

  function getPriceRange() {
    const minInput = document.querySelector(SELECTORS.priceMin);
    const maxInput = document.querySelector(SELECTORS.priceMax);
    if (!minInput || !maxInput) return null;
    return {
      min: parseFloat(minInput.value) * 100 || 0,
      max: parseFloat(maxInput.value) * 100 || Infinity,
    };
  }

  function applyFilters() {
    const filters = getActiveFilters();
    const priceRange = getPriceRange();
    const hasActiveFilters =
      filters.vendor.length > 0 ||
      filters.brand.length > 0 ||
      filters.type.length > 0 ||
      filters.tag.length > 0 ||
      filters.available.length > 0 ||
      (priceRange && priceRange.min > parseFloat(document.querySelector(SELECTORS.priceMin)?.min || 0) * 100) ||
      (priceRange && priceRange.max < parseFloat(document.querySelector(SELECTORS.priceMax)?.max || Infinity) * 100);

    const gridScope = document.querySelector('.item-grid__main') || document;
    const productItems = gridScope.querySelectorAll(SELECTORS.productItem);
    let visibleCount = 0;

    productItems.forEach((item) => {
      const dataEl = item.querySelector(SELECTORS.productData);
      if (!dataEl) return;

      const vendor = dataEl.getAttribute('data-product-vendor') || '';
      const brand = dataEl.getAttribute('data-product-brand') || vendor;
      const price = parseInt(dataEl.getAttribute('data-product-price') || '0', 10);
      const available = dataEl.getAttribute('data-product-available') || 'true';
      const tags = (dataEl.getAttribute('data-product-tags') || '').split('|');
      const type = dataEl.getAttribute('data-product-type') || '';

      let visible = true;

      // Brand filter (OR within group)
      if (filters.brand.length > 0 && !filters.brand.includes(brand)) {
        visible = false;
      }

      // Vendor filter (OR within group)
      if (visible && filters.vendor.length > 0 && !filters.vendor.includes(vendor)) {
        visible = false;
      }

      // Type filter (OR within group)
      if (visible && filters.type.length > 0 && !filters.type.includes(type)) {
        visible = false;
      }

      // Tag filter (OR within group)
      if (visible && filters.tag.length > 0) {
        const hasMatchingTag = filters.tag.some((filterTag) => tags.includes(filterTag));
        if (!hasMatchingTag) {
          visible = false;
        }
      }

      // Availability filter
      if (visible && filters.available.length > 0 && !filters.available.includes(available)) {
        visible = false;
      }

      // Price filter
      if (visible && priceRange) {
        if (price < priceRange.min || price > priceRange.max) {
          visible = false;
        }
      }

      item.style.display = visible ? '' : 'none';
      if (visible) visibleCount++;
    });

    // Update product count
    const countEl = document.querySelector(SELECTORS.productCount);
    if (countEl) {
      countEl.textContent = visibleCount + ' product' + (visibleCount !== 1 ? 's' : '');
    }

    // Show/hide clear button
    const clearWrap = document.querySelector(SELECTORS.clearWrap);
    if (clearWrap) {
      clearWrap.style.display = hasActiveFilters ? 'block' : 'none';
    }

    // Show "no results" message
    const grid = document.querySelector(SELECTORS.productGrid);
    if (grid) {
      let noResults = grid.querySelector('.custom-filter__no-results');
      if (visibleCount === 0) {
        if (!noResults) {
          noResults = document.createElement('div');
          noResults.className = 'custom-filter__no-results';
          noResults.innerHTML = '<p>No products match the selected filters.</p>';
          grid.appendChild(noResults);
        }
        noResults.style.display = 'block';
      } else if (noResults) {
        noResults.style.display = 'none';
      }
    }

    // Update active state on parent li
    document.querySelectorAll(SELECTORS.filterInput).forEach((input) => {
      const li = input.closest('.tag');
      if (li) {
        li.classList.toggle('tag--active', input.checked);
      }
    });
  }

  function clearAllFilters() {
    document.querySelectorAll(SELECTORS.filterInput + ':checked').forEach((input) => {
      input.checked = false;
    });

    // Reset price inputs
    const minInput = document.querySelector(SELECTORS.priceMin);
    const maxInput = document.querySelector(SELECTORS.priceMax);
    if (minInput) minInput.value = minInput.min;
    if (maxInput) maxInput.value = maxInput.max;

    applyFilters();
  }

  /**
   * Sync brand filter list with actual product data attributes on page.
   * This catches brands that Liquid's paginated loop might miss.
   */
  function syncBrandFilter() {
    const brandList = document.querySelector(SELECTORS.brandFilterList);
    if (!brandList) return;

    const existingBrands = new Set();
    brandList.querySelectorAll('.custom-filter__input').forEach((input) => {
      existingBrands.add(input.value);
    });

    const allBrands = new Set();
    const mainGrid = document.querySelector('.item-grid__main') || document;
    mainGrid.querySelectorAll(SELECTORS.productData).forEach((el) => {
      const brand = el.getAttribute('data-product-brand');
      if (brand) allBrands.add(brand);
    });

    // Add any missing brands
    const sorted = Array.from(allBrands).sort();
    sorted.forEach((brand) => {
      if (!existingBrands.has(brand)) {
        const li = document.createElement('li');
        li.className = 'tag';
        li.innerHTML =
          '<label class="custom-filter__label">' +
          '<input type="checkbox" class="custom-filter__input tag__input" value="' +
          brand.replace(/"/g, '&quot;') +
          '" data-filter-type="brand">' +
          '<span class="tag__checkbox"></span>' +
          '<span class="tag__text">' + brand + '</span>' +
          '</label>';
        brandList.appendChild(li);
        li.querySelector('.custom-filter__input').addEventListener('change', applyFilters);
      }
    });

    // Re-sort the list alphabetically
    const items = Array.from(brandList.querySelectorAll('li'));
    items.sort((a, b) => {
      const aText = a.querySelector('.tag__text')?.textContent || '';
      const bText = b.querySelector('.tag__text')?.textContent || '';
      return aText.localeCompare(bText);
    });
    items.forEach((item) => brandList.appendChild(item));
  }

  function init() {
    // Sync brand filter with actual product data
    syncBrandFilter();

    // Checkbox filters
    document.querySelectorAll(SELECTORS.filterInput).forEach((input) => {
      input.addEventListener('change', applyFilters);
    });

    // Price apply button
    const priceApply = document.querySelector(SELECTORS.priceApply);
    if (priceApply) {
      priceApply.addEventListener('click', applyFilters);
    }

    // Price inputs - apply on Enter key
    document.querySelectorAll('.custom-filter__price-input').forEach((input) => {
      input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          applyFilters();
        }
      });
    });

    // Clear all button
    const clearBtn = document.querySelector(SELECTORS.clearBtn);
    if (clearBtn) {
      clearBtn.addEventListener('click', clearAllFilters);
    }
  }

  // Initialize after full DOM is ready
  // Use requestAnimationFrame to ensure all elements are rendered
  function safeInit() {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        init();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', safeInit);
  } else {
    safeInit();
  }
})();
